export default __webpack_public_path__ + "static/media/cult-icon.c24a8d22.svg";